import React from "react";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FontQuicksand } from "../../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../../BuildingBlocks/FontSize";
import { TextColor } from "../../../BuildingBlocks/TextColor";
import { FrontColors } from "../../../../models/FrontColors";
import { WeightMedium } from "../../../WeightMedium/WeightMedium";
import { Image } from "../../../BuildingBlocks/Image";
import { TextAlign } from "../../../BuildingBlocks/TextAlign";
import { Flex } from "../../../BuildingBlocks/Flex";

export const FPGuideMobile = (props: React.PropsWithChildren<{
    imageUrl: string,
    href: string,
    blurb: string,
}>): JSX.Element =>
    <a
        href={props.href}
        target="_blank"
    >
        <SpacingColumn spacing={FrontSpacing.SMALL_3}>
            {/* IMAGE */}
            <Flex justifyContent="end">
                <Image 
                    url={props.imageUrl} 
                    borderRadius="10px" 
                    height="110px" 
                    width="220px" 
                />
            </Flex>

            {/* BLURB */}
            <Blurb blurb={props.blurb} />
        </SpacingColumn>
    </a>;

const Blurb = (props: {blurb: string}): JSX.Element =>
    <Flex justifyContent="end">
        <FontQuicksand>
            <FontSize
                size="17px"
                lineHeight="1.5"
            >
                <TextColor color={FrontColors.NEUTRAL_18}>
                    <WeightMedium>
                        <TextAlign position="right">
                            {props.blurb}
                        </TextAlign>
                    </WeightMedium>
                </TextColor>
            </FontSize>
        </FontQuicksand>
    </Flex>;
